import cx from "classnames";
import React, { memo } from "react";

interface IProps {
  disabled?: boolean;
  onClick: () => void;
}

const AddButtonComponent = ({ disabled, onClick }: IProps) => (
  <a
    className={cx({ "text-success": !disabled, "text-muted": disabled })}
    href="#"
    onClick={e => {
      e.preventDefault();
      e.stopPropagation();
      if (!disabled) {
        onClick();
      }
    }}
    title="Add"
  >
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" fill="white" stroke="#616161" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.00003 3.70017V7V3.70017ZM7.00003 7V10.2998V7ZM7.00003 7H3.7002H7.00003ZM7.00003 7H10.2999H7.00003Z" fill="#616161"/>
      <path d="M7.00003 7H10.2999M7.00003 3.70017V7V3.70017ZM7.00003 7V10.2998V7ZM7.00003 7H3.7002H7.00003Z" stroke="#616161" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </a>
);
AddButtonComponent.displayName = "AddButton";
export const AddButton = memo(AddButtonComponent);
